import { exists } from '@jack-henry/frontend-utils/functions';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-card';
@customElement(tagName)
export class TmCard extends TmBaseComponent {
    @property({ type: Boolean })
    public banner = false;

    @property({ type: Boolean, reflect: true })
    public fullwidth = false;

    @property({ type: Boolean, reflect: true })
    public rounded = true;

    @property({ type: Boolean })
    public border = false;

    @property({ attribute: false })
    public header?: string;

    @property({ attribute: false })
    public subheader?: string;

    protected render() {
        return html`<div
            class=${classMap({
                'w-full bg-primary': true,
                'rounded-lg': this.rounded,
                'border border-brand-content': this.border,
            })}
        >
            ${this.renderHeader()}
            <div
                class=${classMap({
                    'pb-5': !this.banner,
                    'px-4': !this.fullwidth,
                })}
            >
                <slot></slot>
            </div>
        </div>`;
    }

    private renderHeader() {
        if (!this.header) {
            return nothing;
        }
        const subheader = this.subheader
            ? html`<div class="text-xs text-secondary">${this.subheader}</div>`
            : undefined;
        return html`<div
            class=${classMap({
                'px-4 py-3': true,
                'border-b': exists(subheader),
            })}
        >
            <h4 class="font-medium text-header">${this.header}</h4>
            ${subheader}
        </div>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    min-width: var(--tm-card-min-width, 350px);
                    min-height: var(--tm-card-min-height, 300px);
                    box-shadow: var(--content-shadow);
                    border-radius: 0.5rem;
                }
                @media (max-width: 375px) {
                    :host {
                        overflow-x: scroll;
                    }
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmCard;
    }
}
